module.exports = __webpack_public_path__ + "img/shareBar-top.09ba4483.png";